import { Injectable } from '@angular/core';
import { global } from '../../../shared/global';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class schoolfullregistrationrequestService {

  constructor(private http: HttpClient) { }
  fillBoard(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillBoard', data, global.httpOptions);
  }

  fillMedium(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillMedium', data, global.httpOptions);
  }

  fillInstituteType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillInstituteType', data, global.httpOptions);
}

  fillOffice(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillOffice', data, global.httpOptions);
  }

  fillTypeOfTrust(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillTypeOfTrust', data, global.httpOptions);
  }

  fillSection(data) {
    return this.http.post(global.baseAPIUrl + 'Registration/fillSection', data, global.httpOptions);
  }

  fillState(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillState', data, global.httpOptions);
  }

  fillCity(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillCity', data, global.httpOptions);
  }

  fillSchoolType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolType', data, global.httpOptions);
  }

  fillSchoolLocation(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolLocation', data, global.httpOptions);
  }

  fillDesignation(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillDesignation', data, global.httpOptions);
  }

  fillInfrastructure(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillInfrastructure', data, global.httpOptions);
  }

  fillEmployeeType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillEmployeeType', data, global.httpOptions);
  }

  fillEmployeeQualificationType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillQualificationType', data, global.httpOptions);
  }

  saveFullRegistrationRequest(data) {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/saveFullRegistrationRequest', data, global.httpOptions);
  }

  GetFullRegistrationRequestDetail(data) {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/GetFullRegistrationRequestDetail', data, global.httpOptions);
  }

  GetYearWiseDetail(data) {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/GetYearWiseRegistrationDetail', data, global.httpOptions);
  }

  ViewFullRegistrationPendingRequestDetail(data) {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/ViewFullRegistrationPendingRequestDetail', data, global.httpOptions);
  }

  FillYear(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillYearMaster', data, global.httpOptions);
  }
}